<style>
.stories90d-gradient div#app {
    background: linear-gradient(to bottom, #d8db5d 20%, #1ca5f5 100%) !important;
}
.stories90d-gradient .content-wrapper .content {
    padding-top: 115px;
}
</style>
<template>
    <div>
        <app-header :domain_details="domain_details" :is90d="is90d"></app-header>
        <!-- Left side column. contains the sidebar -->
        <app-sidebar :is90d="is90d"></app-sidebar>
        <!-- Content Wrapper. Contains page content -->
        <router-view :key="$route.path" :domain_details="domain_details"></router-view>
        <!-- /.content-wrapper -->
        <app-footer></app-footer>
        <control-sidebar></control-sidebar>
    </div>
</template>
<script>
import Sidebar from './partials/Sidebar.vue';
import Header from './partials/Header.vue';
import Footer from './partials/Footer.vue';
import ControlSidebar from './partials/ControlSidebar.vue';
import axios from 'axios';
import Oidc from 'oidc-client';
import { mapActions } from 'vuex';

let setdata = function (params, path) {
    if (path) for (let key in params) path = path.replace(new RegExp('{' + key + '}', 'g'), params[key]);

    return path;
};
export default {
    name: 'Dashboard',
    components: {
        'app-sidebar': Sidebar,
        'app-header': Header,
        'app-footer': Footer,
        'control-sidebar': ControlSidebar,
    },
    data() {
        return {
            domain_details: {},
            is90d: false,
        };
    },
    created: function () {
        this.fetchDomainDetails();
    },
    watch: {
        $route: function (newUrl, oldUrl) {
            if (
                newUrl.path.indexOf('stories') > -1 ||
                newUrl.path.indexOf('manage-service') > -1 ||
                newUrl.path.indexOf('manage-story') > -1
            ) {
                this.is90d = true;
                document.body.classList.add('stories90d-gradient');
                // document.body.classList.remove('yeti-gradient');
            } else {
                this.is90d = false;
                document.body.classList.remove('stories90d-gradient');
                // document.body.classList.add('yeti-gradient');
            }
            if (newUrl.path !== oldUrl.path) {
                this.fetchDomainDetails();
            }
        },
        deep: true,
    },
    methods: {
        // ...mapActions('auth', ['setUser', 'setToken']),
        fetchDomainDetails() {
            let path = 'v1/publishers/{uuid}/domains/{domId}/';
            let params = Object.keys(this.$route.params);
            if (params.includes('uuid') && params.includes('domId')) {
                console.log('fetch domain details');
                path = setdata(this.$route.params, path);
                axios.get(BASE_URL + path).then((response) => {
                    this.domain_details = response.data;
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// Dashboard.vue?75fefe84